export default [
  {
    name: "Jenifer",
    img: "dailymonday.jpg",
    dialog: [
      {
        author: "me",
        time: 1514323142314,
        content: "안녕 Jenifer. 엄청 오랜만이네. 어떻게 지내?"
      },
      {
        author: "you",
        time: 1514323148314,
        content: "진짜 오랜만이네 ㅎㅎ 난 그냥저냥 지내. 넌 요새 뭐해?"
      },
      {
        author: "me",
        time: 1514323149314,
        content: "나 지그재그 과제하는 중이야 지금. 좋은 회사라 꼭 들어가고 싶네. ㅎㅎ"
      }
    ]
  },
  {
    name: "Sarah",
    img: "imvely.jpg",
    dialog: [
      {
        author: "me",
        time: 1523505045571,
        content: "Sarah, 너 이번에 일본여행 간다며. 재밌겠다~! 언제 가?"
      },
      {
        author: "you",
        time: 1523505545571,
        content: "어떻게 알았어? ㅋㅋ 응 휴가차 가는건데, 2주 뒤로 비행기 끊었어."
      },
      {
        author: "me",
        time: 1523506245571,
        content: "와, 부럽네 ㅋㅋ 우리 대학때 같이 가려다가 무산 됐었잖아ㅋㅋ 이번에 제대로 즐기고 와. 사진 찍어와서 좀 보여줘~!"
      }
    ]
  },
  {
    name: "Azriel",
    img: "miamasvin.jpg",
    dialog: [
      {
        author: "me",
        time: 1526505045571,
        content: "Azriel. 너 한국에 놀러왔다며? ㅎㅎ 언제 왔어? 한국어 공부는 열심히 했어? :)"
      },
      {
        author: "you",
        time: 1526505055571,
        content: "응 지그재그야 안녕. 한국말은 열심히 공부하긴 했는데, 아직 많이 부족해. 너가 좀 도와줘."
      },
      {
        author: "me",
        time: 1526505072571,
        content: "그 정도면 엄청 잘하는 거 같은데..ㅋㅋ 공부 많이 했구나~!"
      }
    ]
  },
  {
    name: "Rebecca",
    img: "mocobling.jpg",
    dialog: [
      {
        author: "me",
        time: 1533185065571,
        content: "Bec. 어떻게 지내? 이번에 남자친구 생겼다며? ㅋㅋ 어쩌다 만나게 됐어? ㅎㅎ "
      },
      {
        author: "you",
        time: 1533185075571,
        content: "ㅋㅋ 소문 빠르네. 원래는 아는 회사 동료였는데, 같은 프로젝트에 참여하게 되면서 서로 알게 됐어. 언제 같이 한번 저녁 먹자 친구야.ㅋㅋ"
      },
      {
        author: "me",
        time: 1533185285571,
        content: "오 사내연애ㅋㅋㅋ 부럽다ㅠ 우리팀원들은 다 남친있어서 난 그런거 꿈도 못 꿔.ㅋㅋ 그래 같이 시간 잡아보자 한번!"
      }
    ]
  },
  {
    name: "Alice",
    img: "partysu.jpg",
    dialog: [
      {
        author: "me",
        time: 1529505045571,
        content: "Hey, what did you do at the Kpop night in melbourne?"
      },
      {
        author: "you",
        time: 1529505065571,
        content: "We hung out with the Japanese girls we run into at the mall the other day. It was so much fun. They are like crazy good at clubbing lol"
      },
      {
        author: "me",
        time: 1529505075571,
        content: "Oh, It's a shame that I wasn't there. are you guys hanging out again?"
      }
    ]
  },
  {
    name: "Abigale",
    img: "dailymonday.jpg",
    dialog: [
      {
        author: "me",
        time: 1529525045571,
        content: "Abi. 회사 합격한 거 축하해. 너무 부럽다 ㅜ"
      },
      {
        author: "you",
        time: 1529525055571,
        content: "고마워 지그재그야. 너도 곧 좋은 회사 들어가게 될거야~! 지금 뭐해?"
      },
      {
        author: "me",
        time: 1529525065571,
        content: "나 지그재그 과제중이야. 이 회사 돠게 훌륭한 것 같아서 꼭 들어가보고 싶은 느낌이 팍팍드네."
      }
    ]
  },
  {
    name: "Emma",
    img: "imvely.jpg",
    dialog: [
      {
        author: "me",
        time: 1530985065571,
        content: "Emma, 나 지금 지그제그 코딩 과제중인데, 좀 도와줄 수 있어? 너 자바스크립트 신이잖아.ㅜ 헬프 미~"
      },
      {
        author: "you",
        time: 1530985085571,
        content: "학교 다닐때 그렇게 통했지ㅋㅋ 뭐가 궁금해? ES6는 공부하고 과제하는 거야?"
      },
      {
        author: "me",
        time: 1530985125571,
        content: "ES6 공부할게 너무 많아. ㅠ 어디부터 해야됨? 좋은 사이트 좀 추천해줘~"
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/js/userList.js